import { render, staticRenderFns } from "./BankIdSettings.vue?vue&type=template&id=240a2ed2&scoped=true"
import script from "./BankIdSettings.vue?vue&type=script&lang=js"
export * from "./BankIdSettings.vue?vue&type=script&lang=js"
import style0 from "./BankIdSettings.vue?vue&type=style&index=0&id=240a2ed2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240a2ed2",
  null
  
)

export default component.exports